import { inject, Injectable } from "@angular/core";
import { FileApi } from "../Api/FileApi";
import { FileState } from "./FileState";
import { SearchFileRequest } from "../Dto/SearchFileRequest";
import { createBackendError, getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable({ providedIn: "root" })
export class FileEffects {
  private readonly fileApi = inject(FileApi);
  private readonly fileState = inject(FileState);

  async searchFiles(payload: SearchFileRequest): Promise<void> {
    this.fileState.setLoading(true);
    this.fileState.setError(null);
    this.fileState.setSearchParams(payload);

    try {
      const response = await this.fileApi.searchFiles(payload);
      this.fileState.setFiles(response.data, response.pagination);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.fileState.setError(errorMessage);
    } finally {
      this.fileState.setLoading(false);
    }
  }

  async uploadFile(file: globalThis.File, folder: string): Promise<void> {
    this.fileState.setLoading(true);
    this.fileState.setError(null);

    try {
      const response = await this.fileApi.uploadFile(file, { folder });
      this.fileState.addFile(response);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.fileState.setError(errorMessage);
      throw createBackendError(exception);
    } finally {
      this.fileState.setLoading(false);
    }
  }

  async deleteFile(name: string): Promise<void> {
    this.fileState.setLoading(true);
    this.fileState.setError(null);

    try {
      await this.fileApi.deleteFile(name);
      // Remove the file from the state after successful deletion
      // We need to find the file ID based on the name
      const files = this.fileState.data();
      const fileToDelete = files.find((f) => f.name === name);
      if (fileToDelete) {
        this.fileState.removeFile(fileToDelete.id);
      }
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.fileState.setError(errorMessage);
      throw createBackendError(exception);
    } finally {
      this.fileState.setLoading(false);
    }
  }
}
